import { ReactNode } from 'react';
import Link from 'next/link';
import { useTranslation as t } from '../../hooks/useTranslation';
import { EpIcon } from '../EpIcon';
import { IHospitalInfo, useTranslationStore } from '../../stores';
import styles from './EpSearchFooter.module.scss';

interface IEpSearchFooter {
  children?: ReactNode;
  searchFooterButtonLeftRoute: string;
  searchFooterButtonRightRoute: string;
  searchParams?: IHospitalInfo;
  translations: string[];
}

export function EpSearchFooter({
  children,
  searchFooterButtonLeftRoute,
  searchFooterButtonRightRoute,
  searchParams,
  translations,
}: IEpSearchFooter) {
  const { translations: global } = useTranslationStore();

  return (
    <div className={styles['footer']}>
      <Link
        href={{
          pathname: searchFooterButtonLeftRoute,
          query: {
            ...searchParams,
          },
        }}
        className={styles['footer__link']}
      >
        <EpIcon iconName="SolidLongArrowAltLeft" />
        {t(translations, 'Back')}
      </Link>

      {children}

      <Link
        href={{
          pathname: searchFooterButtonRightRoute,
          query: {
            ...searchParams,
          },
        }}
        className={styles['footer__link']}
      >
        {t(global['global'], 'Create notification')}
        <EpIcon iconName="SolidLongArrowAltRight" iconSize={14} />
      </Link>
    </div>
  );
}
